<template>
  <Head title="Playbook Editor" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <playbook-type-list 
            :playbook_types="playbook_types" 
            :asset_types="asset_types"
          ></playbook-type-list>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  playbook_types: Array,
  asset_types: Array
});
</script>

